interface AppEnv {
  environment: string
  dataRegion: string | null
  backendDomain: string
  backendPath: string
}

export class AppEnvNotInjectedError extends Error {
  constructor() {
    super('window.__APP_ENV__ is not defined; index.html placeholder not injected')
    this.name = 'AppEnvNotInjectedError'
  }
}

export function getAppEnv(): AppEnv {
  const w = typeof window !== 'undefined' ? window.__APP_ENV__ : undefined
  if (!w) {
    throw new AppEnvNotInjectedError()
  }
  return {
    environment: w.environment,
    dataRegion: w.dataRegion ?? null,
    backendDomain: w.backend.domain,
    backendPath: w.backend.path,
  }
}

export function getRegion(): string {
  const region = getAppEnv().dataRegion
  if (!region) {
    throw new Error('dataRegion is not set in window.__APP_ENV__')
  }
  return region
}
